import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ProfileSystemPageLayout from "../layout/profileSystem/ProfileSystemPageLayout";

function ProfileSystemPage() {

  return (
    <>
      <Routes>
        <Route path="/" element={<ProfileSystemPageLayout />} />
      </Routes>
    </>
  )
}

export default ProfileSystemPage
